import React from 'react';
import './CookiesPopup.scss';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import Button from 'Components/Shared/Button/Button';

interface IProps {
  content: Julius.Website.CookiesNotificationViewModel;
  onOK: () => void;
}

const CookiesPopup: React.SFC<IProps> = ({
  content: {
    title,
    text,
  },
  onOK,
}) => (
  <div className='cookies-popup'>
    <div className='left'>
      <div className='cookies-title'>{ title }</div>
      <Button onClick={ onOK } color='purple'>
        <FormattedText
          displayName='Jag förstår'
          formattedName='cookies.agree'
        />
      </Button>
    </div>
    <div className='cookies-text' dangerouslySetInnerHTML={ { __html: text } } />
  </div>
);

export default CookiesPopup;


// WEBPACK FOOTER //
// ./src/components/CookiesPopup/CookiesPopup.tsx